var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H1C0.4375 6 0 6.46875 0 7V9C0 9.5625 0.4375 10 1 10H3C3.53125 10 4 9.5625 4 9V7C4 6.46875 3.53125 6 3 6ZM8 6H6C5.4375 6 5 6.46875 5 7V9C5 9.5625 5.4375 10 6 10H8C8.53125 10 9 9.5625 9 9V7C9 6.46875 8.53125 6 8 6ZM13 6H11C10.4375 6 10 6.46875 10 7V9C10 9.5625 10.4375 10 11 10H13C13.5312 10 14 9.5625 14 9V7C14 6.46875 13.5312 6 13 6ZM3 0H1C0.4375 0 0 0.46875 0 1V3C0 3.5625 0.4375 4 1 4H3C3.53125 4 4 3.5625 4 3V1C4 0.46875 3.53125 0 3 0ZM8 0H6C5.4375 0 5 0.46875 5 1V3C5 3.5625 5.4375 4 6 4H8C8.53125 4 9 3.5625 9 3V1C9 0.46875 8.53125 0 8 0ZM13 0H11C10.4375 0 10 0.46875 10 1V3C10 3.5625 10.4375 4 11 4H13C13.5312 4 14 3.5625 14 3V1C14 0.46875 13.5312 0 13 0Z",
    fill: "#008ffb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageView);
export default __webpack_public_path__ + "static/media/image_view.132e4328456b6fd447d7b555e3ede655.svg";
export { ForwardRef as ReactComponent };